import * as React from 'react';
import LanguageButton from './LanguageButton';
import styled from '../theme';

interface ILangWrapperProps {
    isPreArrival?: boolean
}

const LangWrapper = styled<ILangWrapperProps, 'div'>('div')`
    display: flex;
    justify-content: center;
    width: 100%;
    padding-top:${(props: any) => props.isPreArrival ? '16px': 'initial'}
    padding-bottom:${(props: any) => props.isPreArrival ? '16px': 'initial'}
    background: ${(props: any) => props.isPreArrival ? 'white' : 'initial'}
`

interface ILanguageSwitcherProps {
    content: any
    locale: string
    changeLocale: any
}

const LanguageSwitcher = (props: ILanguageSwitcherProps) => {
    return (
        <LangWrapper isPreArrival={props.content.isPreArrival}>
            <LanguageButton
                locale={props.content.localeEnglishLabel}
                class={props.locale === 'en-au' ? 'selected' : ''}
                changeLocale={props.changeLocale}
                isPreArrival={props.content.isPreArrival}
                id="en-au" />
            <LanguageButton
                locale={props.content.localeSimplifiedChineseLabel}
                class={props.locale === 'zh-cn' ? 'selected' : ''}
                isPreArrival={props.content.isPreArrival}
                changeLocale={props.changeLocale}
                id="zh-cn" />
        </LangWrapper>
    )
}

export default LanguageSwitcher



// WEBPACK FOOTER //
// ./src/components/LanguageSwitcher.tsx